<template>
  <span v-if="diaplyName" class="member-classes-period-type"> {{ diaplyName }} </span>
</template>

<script>
import { CoursePeriodsType } from '@/utils/enums';
export default {
  name: 'CoursePeriodsType',
  props: {
    periods_type: {
      require: true,
    },
    short: {
      default: false,
    },
  },
  computed: {
    diaplyName() {
      if (!this.periods_type) {
        return '';
      }

      const name = CoursePeriodsType.getValue(this.periods_type);
      return this.short ? name.slice(0, name.length - 1) : name;
    },
  },
};
</script>

<style>
.member-classes-period-type {
  display: inline-block;
  padding: 0 4px;
  font-size: 12px;
  line-height: 20px;
  color: #ff4242;
  background: #ffffff;
  border-radius: 4px;
  border: 0.5px solid #f4272f;
  margin-right: 8px;
  white-space: nowrap;
}
</style>
